import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Grid2 as Grid, Stack } from '@mui/material';

function BackAction({ backLabel = 'Back To List', link, actionElement, sx, state, ...rest }) {
    const navigate = useNavigate();

    const handleClick = () => {
        if (link) {
            navigate(link, { state });
        } else {
            navigate(-1, { state });
        }
    };

    return (
        <Stack
            direction="row"
            {...rest}
            sx={[{
                justifyContent: "space-between",
                alignItems: "center",
                mt: 2,
                width: '100%',
                ...sx
            }, ...(Array.isArray(rest.sx) ? rest.sx : [rest.sx])]}>
            <Button color="primary" onClick={handleClick}>
                {backLabel}
            </Button>
            {actionElement}
        </Stack>
    );
}

export default BackAction;

// write react prop types
